export default __webpack_public_path__ + "static/guideSection-1d150d9f7ea684669a80b55d866c92d9.jpeg";